/* eslint-disable no-param-reassign */
import { generateUUID } from "shared/lib/generateUUID"

import { PayloadAction } from "@reduxjs/toolkit"
import { produce } from "immer"

import { Overlay, OverlayReducerState, OverlayType } from "./types"

export function openOverlayHandler(
  state: OverlayReducerState,
  action: PayloadAction<{ overlay: Omit<Overlay, "id"> }>
) {
  if (
    action.payload.overlay.options?.id &&
    state.overlays.some(o => o.id === action.payload.overlay.options?.id)
  ) {
    return state
  }
  return produce(state, writableState => {
    writableState.overlays.push({
      ...(action.payload.overlay as Overlay),
      id: action.payload.overlay.options?.id || generateUUID()
    })
  })
}

export function closeOverlayByIDHandler(
  state: OverlayReducerState,
  action: PayloadAction<{ id: string }>
) {
  const overlay = state.overlays.find(o => o.id === action.payload.id)
  if (!overlay) {
    return state
  }
  overlay.options?.onClose?.()
  return produce(state, writableState => {
    writableState.overlays = state.overlays.filter(
      o => o.id !== action.payload.id
    ) as Overlay[]
  })
}

export function closeOverlayByTypeHandler(
  state: OverlayReducerState,
  action: PayloadAction<{ type: OverlayType }>
) {
  const overlays = state.overlays.filter(
    overlay => overlay.type === action.payload.type
  )
  if (overlays.length === 0) {
    return state
  }
  overlays.forEach(overlay => overlay.options?.onClose?.())
  return produce(state, writableState => {
    writableState.overlays = state.overlays.filter(
      overlay => overlay.type !== action.payload.type
    )
  })
}

export function closeAllOverlaysHandler(state: OverlayReducerState) {
  return produce(state, writableState => {
    writableState.overlays = []
  })
}
